import { Component } from '@angular/core';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { CompaniesService } from 'src/app/services/api/general-settings/companies.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-companies-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './companies-detail-page.component.html',
  styleUrl: './companies-detail-page.component.scss'
})
export class CompaniesDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  company?: any;

  constructor(
    private companiesService: CompaniesService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Companies',
      cardTitle: 'Company Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Company',
        onClick: () => {
          this.routeService.companyUpdate(this.company.companyId)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
          {
            attribute: 'country',
            label: 'Country',
            value: (item: any) => {
              return item.country.name;
            }
          },
        ]
      },
      apiDetailService: (companyId: number) => this.companiesService.detail(companyId),
      routeParamName: 'companyId',
      responseModelName: 'company'
    };

  }

  onLoadedDetail(data: any) {
    this.company = data;
  }
}
